<template>
    <span :class="['text-style', color]">
        <slot/>
    </span>
</template>

<script>
export default {
    name: 'text-style',
    props: {
        color: String,
    },
};
</script>

<style lang="scss">
@import 'global/default';

.text-style.red {
    color: $color-primary-300;
}

</style>
